import { Flex, Text } from "@mantine/core";
import Link from "next/link";
import { memo } from "react";
import { MdFavoriteBorder } from "react-icons/md";
import { AvatarIconMemo } from "src/component/element/AvatarIcon";
import { RankingScoreIcon } from "src/component/element/RankingItem/RankingScoreIcon";
import type { FavoriteRanking } from "src/service/RankingApi/types";
import { useGetUserSettingsQuery } from "src/service/UsersApi";

import styles from "./RankingItem.module.scss";

const FavoriteRankingItem = ({ rank, score, user }: FavoriteRanking) => {
  const { data: userData } = useGetUserSettingsQuery();
  const userId = userData?.id;
  return (
    <Link
      className={rank == 3 ? styles.rankingTop3Item : styles.ranking}
      href={user.id === userId ? `/mypage` : `/other/${user.id}`}
      passHref
      aria-label="ユーザーページへ遷移"
    >
      <div
        className={
          rank <= 3
            ? user.id == userId
              ? styles.rankingBackGroundTopItemOwn
              : styles.rankingBackGroundTopItem
            : user.id == userId
            ? styles.rankingBackGroundOwn
            : styles.rankingBackGround
        }
      >
        <Flex align="center">
          <div className={styles.rankingNumber}>
            <RankingScoreIcon rank={rank} />
            <p
              className={rank <= 3 ? styles.rankNumberWhite : styles.rankNumber}
            >
              {rank}
            </p>
          </div>
          <div className={styles.avatarWrap}>
            <AvatarIconMemo
              avatar={user.profileImage}
              background={user.profileBgImage}
            />
          </div>

          <div className={styles.rankingTexts}>
            <Text size={12}>{user?.nickname}</Text>
          </div>
          <Flex
            align="center"
            justify="space-between"
            className={styles.niceWrap}
            gap={4}
          >
            <MdFavoriteBorder size={20} style={{ width: "40%" }} />
            <Text className={styles.score}>{score}</Text>
          </Flex>
        </Flex>
        {!!user?.topFavoriteReason?.length && (
          <Flex>
            <div className={styles.rankingNumber} />
            <div className={styles.avatarWrap} />
            <div className={styles.rankingTexts}>
              <Text size={11} className={styles.favoriteHead}>
                <MdFavoriteBorder /> 推しポイント
              </Text>
              <Text size={11} lineClamp={3}>
                {user.topFavoriteReason}
              </Text>
            </div>
          </Flex>
        )}
      </div>
    </Link>
  );
};

export const FavoriteRankingItemMemo = memo(FavoriteRankingItem);
